module.exports = __webpack_public_path__ + "img/icon_explosives.b7d8c205.png";